<template>
  <FlatActionButton
    :action="() => handleClick(item)"
    data-test-id="CommandTemplateConfigureButton__Button"
  >
    {{ buttonText }}
  </FlatActionButton>
</template>

<script>
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';

export default {
  name: 'CommandTemplateConfigureButton',

  components: {
    FlatActionButton,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    handleClick: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
